import { render, staticRenderFns } from "./wastes.vue?vue&type=template&id=a8739bc6"
import script from "./wastes.vue?vue&type=script&lang=js"
export * from "./wastes.vue?vue&type=script&lang=js"
import style0 from "./wastes.vue?vue&type=style&index=0&id=a8739bc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports